import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import PageTitle from "../components/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { updateNews } from "../redux/actions/newsAction";
import { NEWS_UPDATE_RESET } from "../redux/constants/newsConstant";

const EditNewsScreen = () => {
  const { uuid } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const listNewsDetail = useSelector((state) => state.listNewsDetail);
  const { newsDetail } = listNewsDetail;
  const newsEditState = useSelector((state) => state.newsEdit);
  const { success } = newsEditState;
  const [title, setTitle] = useState("");
  const [link, setLink] = useState("");
  const [description, setDescription] = useState("");
  const handleSubmitEditForm = (e) => {
    e.preventDefault();
    dispatch(updateNews(title, link, description, uuid));
  };

  useEffect(() => {
    if (success) {
      navigate("/news");
      dispatch({ type: NEWS_UPDATE_RESET });
    }
  }, [success]);
  return (
    <Layout>
      <PageTitle title="Edit Event" />
      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmitEditForm}>
            <div className="row mb-3">
              <label htmlFor="name" className="col-sm-2 col-form-label">
                News Title
              </label>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter Title for News"
                  onChange={(e) => setTitle(e.target.value)}
                  defaultValue={newsDetail && newsDetail.title}
                />
              </div>
            </div>
            <div className="row mb-3">
              <label
                htmlFor="example-week-input"
                className="col-sm-2 col-form-label"
              >
                Link For News
              </label>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter Link for News"
                  onChange={(e) => setLink(e.target.value)}
                  defaultValue={newsDetail && newsDetail.link}
                />
              </div>
            </div>
            <div className="row mb-3">
              <label htmlFor="name" className="col-sm-2 col-form-label">
                News Description
              </label>
              <div className="col-sm-10">
                <textarea
                  className="form-control"
                  type="text"
                  // rows={9}
                  placeholder="Enter Small Description For News"
                  onChange={(e) => setDescription(e.target.value)}
                  defaultValue={newsDetail && newsDetail.description}
                ></textarea>
              </div>
            </div>

            <button type="submit" className="btn btn-primary">
              Edit
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default EditNewsScreen;
